export default __webpack_public_path__ + "static/media/221.27b4265b.png";